import { useConfiguration } from '../../../../context/configurationContext';

export const toSelectFormat = value => (value ? { value, label: value } : null);
export const toSelectFormatCapacity = value =>
  value ? { value, label: (value / 10).toFixed(1) } : null;

export const categoryToOptions = category => {
  const mainConfig = useConfiguration();
  const categories = mainConfig.listing.listingFields;

  const config = categories.find(cat => cat.key === category);
  const options = config.enumOptions.map(el => ({
    value: el.option,
    label: el.label,
  }));
  return options;
};

export const categoryToRangeOptions = (category, step, ending, isReversed = false) => {
  const mainConfig = useConfiguration();
  const categories = mainConfig.listing.listingFields;

  const config = categories.find(cat => cat.key === category);
  if (!config) return [null, null];
  const max = config.maximum || 500000;
  const min = config.minimum || 0;
  let options = Array.from({ length: (max - min) / step }, (_, i) => ({
    value: max - i * step,
    label: `${max - i * step} ${ending ? ending : ''}`,
  }));
  options = isReversed ? options.reverse() : options;
  return [config, options];
};

export const capacityToRangeOptions = (category, step, ending, isReversed = false) => {
  const mainConfig = useConfiguration();
  const categories = mainConfig.listing.listingFields;

  const config = categories.find(cat => cat.key === category);
  if (!config) return [null, null];

  const max = config.maximum || 2000;
  const min = config.minimum || 0;

  let options = [];
  if (category === 'enginecapacity') {
    options = Array.from({ length: (max - min) / step }, (_, i) => ({
      value: max - i * step,
      label: `${((max - i * step) / 10).toFixed(1)} ${ending ? ending : ''}`,
    }));
  } else {
    options = Array.from({ length: (max - min) / step }, (_, i) => ({
      value: max - i * step,
      label: `${max - i * step} ${ending ? ending : ''}`,
    }));
  }
  options = isReversed ? options.reverse() : options;
  return [config, options];
};

export const yearToRangeOptions = () => {
  const mainConfig = useConfiguration();
  const categories = mainConfig.listing.listingFields;

  const config = categories.find(cat => cat.key === 'year');
  if (!config) return [null, null];
  const max = config.maximum || 2025;
  const min = config.minimum || 1980;
  let result = [];

  let full = min;
  while (full < max) {
    result.push({
      value: full,
      label: `${full}`,
    });
    full += 1;
  }
  return [config, result];
};

export const mileageToRangeOptions = () => {
  const mainConfig = useConfiguration();
  const categories = mainConfig.listing.listingFields;

  const config = categories.find(cat => cat.key === 'mileage');
  if (!config) return [null, null];
  const max = config.maximum || 500000;
  const min = config.minimum || 0;
  let result = [];

  let full = min;
  while (full < max) {
    if (full < 50000) {
      full += 10000;
      result.push({
        value: full,
        label: `${full} km`,
      });
      continue;
    }
    if (full < 200000) {
      full += 25000;
      result.push({
        value: full,
        label: `${full} km`,
      });
      continue;
    } else {
      full += 50000;
      result.push({
        value: full,
        label: `${full} km`,
      });
      continue;
    }
  }
  return [config, result];
};

export const powerToRangeOptions = () => {
  const mainConfig = useConfiguration();
  const categories = mainConfig.listing.listingFields;

  const config = categories.find(cat => cat.key === 'horsepower');
  if (!config) return [null, null];
  const max = config.maximum || 2000;
  const min = config.minimum || 0;
  let result = [];

  let full = min;
  while (full < max) {
    if (full < 150) {
      full += 25;
      result.push({
        value: full,
        label: `${full} CV`,
      });
      continue;
    } else if (full < 500) {
      full += 50;
      result.push({
        value: full,
        label: `${full} CV`,
      });
      continue;
    } else {
      full += 150;
      result.push({
        value: full,
        label: `${full} CV`,
      });
      continue;
    }
  }
  return [config, result];
};

export const priceToRangeOptions = () => {
  const max = 500000;
  const min = 4000;
  let result = [];

  let full = min;
  while (full < max) {
    if (full < 10000) {
      full += 1000;
      result.push({
        value: full,
        label: `${full} €`,
      });
      continue;
    } else if (full < 50000) {
      full += 5000;
      result.push({
        value: full,
        label: `${full} €`,
      });
      continue;
    } else if (full < 100000) {
      full += 10000;
      result.push({
        value: full,
        label: `${full} €`,
      });
      continue;
    } else {
      result.push({
        value: 500000,
        label: `100000+`,
      });
      break;
    }
  }
  return result;
};

export const doubleStyles = {
  control: base => ({
    ...base,
    border: 'none',
    height: '46px',
  }),
};

export const checkoutStyles = {
  valueContainer: base => ({
    ...base,
    display: 'flex',
    flexWrap: 'nowrap',
    overflowX: 'auto',
    maxWidth: '100%',
    whiteSpace: 'nowrap',
    maxWidth: '400px',
  }),
};
